import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../../../hooks/hooks";
import { selectUsersListItems } from "../../../../../../../../redux/users/selector";
import { users } from "../../../../../../../../redux/users/action";
import PageLoader from "../../../../../../../../components/PageLoader";
import { useNavigate, useParams } from "react-router-dom";

const ManagementAccountUsers = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const parmas: any = useParams()
    const [pageData, setPageData] = useState(1)
    const userItems = useSelector(selectUsersListItems)
    const [columnDefs, setColumnDefs] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'FirstName', headerName: 'First Name' },
            { field: 'LastName', headerName: 'Last Name' },
            { field: 'UserType', headerName: 'User Type' },
            { field: 'CompanyName', headerName: 'Company Name' },
            { field: 'Email', headerName: 'Email' },
            { field: 'PhoneNumber', headerName: 'Phone Number' },
        ]);
    }

    const fetchAccountUsersList = () => {
        dispatch(users.list({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/iam/users/list`,
            entity: 'users',
            jsonData: {
                "Filters": [
                    {
                        "FieldName": "AccountId",
                        "FilterOperatorId": 1,
                        "FieldValue": parmas?.id,
                        "FieldType": "number"
                    }
                ],
            }
        }));
    }

    useEffect(() => {
        createColumnDefs()
        fetchAccountUsersList()
    }, [pageData])

    const additionButtons: any = [
        {
            name: 'Add Users',
            callback: () => handleAdd(),
        }
    ];

    const handleAdd = () => {
        navigate(`/management/organization/rms/accounts/${parmas.id}/account-users`)
    }

    return (
        <>
            {userItems?.isLoading ?
                <PageLoader /> :
                <Table columnData={columnDefs} rowData={userItems?.result?.items} setPageData={setPageData}
                    paginationData={userItems?.result?.pagination}
                    additionButtons={additionButtons} headingName="Account Users" />
            }
        </>
    );
};

export default ManagementAccountUsers;
